module.exports = __webpack_public_path__ + "static/media/advanced-filter-icon.2cecd45e.svg";